import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {SetSessionId, SetSessionIdActionTypes} from "../actions/Actions";
import {AnyAction} from "redux";

export type AlmeConversationState = AlmeState["Conversation"];

export default function reduce(state: AlmeConversationState = defaultState.Conversation, action: AnyAction): AlmeConversationState
{
    let typedAction: SetSessionIdActionTypes;
    switch(action.type)
    {
        case "SET_SESSION_ID":
            typedAction = action as SetSessionId;
            return {
                ...state,
                 SessionId: typedAction.payload.sessionId,
                 IsActiveSession: typedAction.payload.isActiveSession,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/session/src/reducers/index.ts